<ng-template #modalSuccess let-c="close" let-d="dismiss">
  <wsb-modal title="{{ '' | translate }}" (dismiss)="d()" (primary)="goToEmailCampaignHistory()" text="{{ '' | translate }}">
    <div body>
      <span class="icon" [inlineSVG]="'assets/images/icons/icon-success.svg'"></span>
      <span>{{ 'editor_mailsuccess' | translate }}</span>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalSubscriptionError let-c="close" let-d="dismiss">
  <wsb-modal title="{{ 'mail_no_subscription_title' | translate }}" (dismiss)="d()" (primary)="d()" primaryButtonText="common_close">
    <div body>
      <div [innerHtml]="'mail_not_subscribed_to_service' | translate"></div>
    </div>
  </wsb-modal>
</ng-template>

<div class="page">
  <div class="page__container " #page>
    <h1 class="page__title h2">{{ 'mail_send_title' | translate }}</h1>
    <wsb-atlas-step class="mb-4" [numSteps]="5" [currentStep]="currentStep"></wsb-atlas-step>

    <div [ngSwitch]="currentStep">
      <wsb-email-create-setup
        [emailCampaignIssue]="emailCampaignIssue"
        (template)="hasTemplate($event)"
        (enableNextButton)="enableButton($event)"
        *ngSwitchCase="1"
      ></wsb-email-create-setup>
      <wsb-email-create-template
        [templateId]="templateId"
        (selectedTemplateId)="selectedTemplateId($event)"
        [emailCampaignIssue]="emailCampaignIssue"
        *ngSwitchCase="2"
      ></wsb-email-create-template>
      <wsb-email-create-editor *ngSwitchCase="3"></wsb-email-create-editor>
      <wsb-email-create-recipients [hidden]="currentStep !== 4" [emailCampaignIssue]="emailCampaignIssue"></wsb-email-create-recipients>
      <wsb-email-create-summary
        (enableSendButton)="enableButton($event)"
        *ngSwitchCase="5"
        [emailCampaignIssue]="emailCampaignIssue"
      ></wsb-email-create-summary>
    </div>

    <div class="page__actions  actions-bar" #actionsBar style="z-index: 3">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex">
          <button
            #submitBtn
            class="btn btn-primary btn-sm"
            (click)="nextButton()"
            *ngIf="currentStep !== 5 && currentStep !== 2 && !summary"
            [disabled]="!nextButtonEnable && currentStep !== 4"
            translate
          >
            {{ 'mail_next' }}
          </button>
          <button
            #submitBtn
            class="btn btn-primary btn-sm"
            (click)="nextButton()"
            *ngIf="currentStep === 5"
            [disabled]="!nextButtonEnable"
            translate
          >
            {{ 'common_send' }}
          </button>
          <button
            #submitBtn
            class="btn btn-primary btn-sm"
            (click)="goToEditor()"
            *ngIf="currentStep === 2"
            [disabled]="!nextButtonEnable"
            translate
          >
            {{ 'mail_go_to_empty_editor' }}
          </button>
          <button
            #submitBtn
            class="btn btn-primary ms-3 btn-sm"
            (click)="nextButton()"
            *ngIf="summary"
            [disabled]="!nextButtonEnable"
            translate
          >
            {{ 'mail_summary' }}
          </button>

          <button class="btn  btn-secondary ms-3 btn-sm" *ngIf="currentStep !== 1 && !summary" (click)="backButton()">
            {{ 'common_back' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
